export default __webpack_public_path__ + "static/media/band10.3cb668d2.jfif";